









































































import {
  toRef, computed, defineComponent, useContext,
} from '@nuxtjs/composition-api';
import type { PropType } from '@nuxtjs/composition-api';
import userAddressesGetters from '~/modules/customer/getters/userAddressesGetters';
import type { TransformedCustomerAddress } from '~/modules/customer/composables/types';
import { SfBadge } from './StorefrontUi';

export default defineComponent({
  name: 'UserAddressDetails',
  components: {
    SfBadge,
  },
  props: {
    address: {
      type: Object as PropType<TransformedCustomerAddress>,
      required: true,
    },
    showDefaultBadges: {
      type: Boolean,
      default: true,
    },
  },
  setup(props) {
    const { i18n } = useContext();
    const address = toRef(props, 'address');
    const userAddress = computed(() => ({
      firstName: userAddressesGetters.getFirstName(address.value),
      lastName: userAddressesGetters.getLastName(address.value),
      street: userAddressesGetters.getStreetName(address.value),
      streetNumber: userAddressesGetters.getApartmentNumber(address.value),
      postalCode: userAddressesGetters.getPostCode(address.value),
      city: userAddressesGetters.getCity(address.value),
      province: userAddressesGetters.getProvince(address.value) || '',
      country: userAddressesGetters.getCountry(address.value),
      phone: userAddressesGetters.getPhone(address.value),
      company: userAddressesGetters.getCompanyName(address.value),
      vatId: userAddressesGetters.getTaxNumber(address.value),
      companyEmail: userAddressesGetters.getCompanyEmail(address.value),
      invoiceEmail: userAddressesGetters.getInvoiceEmail(address.value),
      isDefault: userAddressesGetters.isDefault(address.value),
      isDefaultShipping: userAddressesGetters.isDefaultShipping(address.value),
      isDefaultBilling: userAddressesGetters.isDefaultBilling(address.value),
    }));

    const isDefaultShippingText = computed(() => (userAddress.value.isDefaultShipping ? i18n.t('Default delivery address') : ''));

    const isDefaultBillingText = computed(() => (userAddress.value.isDefaultBilling ? i18n.t('Default billing address') : ''));

    return {
      userAddress,
      isDefaultShippingText,
      isDefaultBillingText,
    };
  },
});
